<template>
  <dropdown
    :classes="{ 'columns-dropdown': true }"
    :contentClasses="containerMidEnabled"
    :close-on-click-inside="false"
    v-if="!hideColumnSelector"
  >
    <template
      slot="button"
      slot-scope="scope"
    >
      <button
        class="Fuell-ColumnButton"
        @click="scope.toggle"
      >
        <img
          class="button-column-icon"
          :src="require('@/assets/img/icons/icon-columns.svg')"
          alt="columns"
        />
        <img
          class="button-arrow-icon"
          :src="require('@/assets/img/icons/icon-drop-down.svg')"
          alt="columns"
        />
      </button>
    </template>
    <template slot="default">
      <div
        :key="column.key"
        v-for="column in columns"
      >
        <div
          class="list-item"
          v-if="isColumnModifiable(column)"
        >
          <span
            class="clickable"
            @click="toggleColumn(column)"
          >{{$t(column.name)}}</span>
          <span
            class="Fuell-Toggle-switch"
            :class="{'Fuell-Toggle-switch--enabled': column.visible, 'Fuell-Toggle-switch--disabled': !column.visible}"
            @click="toggleColumn(column)"
            role="button"
          >
            <span
              class="Fuell-Toggle-switch--sphere"
              :class="{'Fuell-Toggle-switch--sphere--enabled': column.visible, 'Fuell-Toggle-switch--sphere--disabled': !column.visible}"
            ></span>
          </span>
        </div>
      </div>
    </template>
  </dropdown>
</template>

<script>
import Dropdown from '../Commons/Dropdown'
export default {
  name: 'TableColumnSelector',
  components: { Dropdown },
  props: {
    columns: {
      type: [Object, Array],
      required: true
    },
    hideColumnSelector: {
      type: Boolean,
      default: false
    },
    midContainer: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    isColumnModifiable (column) {
       return column.modifiable
    },
    toggleColumn (column) {
      this.$emit('toggleColumn', column)
    }
 },
 computed: {
  containerMidEnabled () {
    return this.midContainer ? 'container-mid' : ''
  }
 }

}
</script>

<style >
.container-mid {
  width:230px!important;
}
</style>
